// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scale_cover__U-5RL {
  background: rgba(0, 0, 0, 0.5);
  width: 25px;
  height: 25px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.5s;
  z-index: 1000;
  opacity: 0.9; }
  .scale_cover__U-5RL:hover {
    background: #212121;
    opacity: 1; }
`, "",{"version":3,"sources":["webpack://./src/components/zoomOut/scale.module.scss"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,YAAY,EAAA;EAXd;IAaI,mBAA+B;IAC/B,UAAU,EAAA","sourcesContent":[".cover {\n  background: rgba(0, 0, 0, 0.5);\n  width: 25px;\n  height: 25px;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  transition: all 0.5s;\n  z-index: 1000;\n  opacity: 0.9;\n  &:hover{\n    background: rgba(33, 33, 33, 1);\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cover": `scale_cover__U-5RL`
};
export default ___CSS_LOADER_EXPORT___;
